// MyAccount overlay route names (used by the internal native-stack navigator).
// Kept as a single source of truth so UI elements can reference routes consistently.
const NavigationElements = {
  menu: 'Menu',
  myProfile: 'MyProfile',
  idVerification: 'IdVerification',
  myRewards: 'MyRewards',
  myTransactions: 'MyTransactions',
  transactionDetail: 'TransactionDetail',
  settings: 'Settings',
  settingsTheme: 'SettingsTheme',
  settingsLanguage: 'SettingsLanguage',
  settingsNotifications: 'SettingsNotifications',
  help: 'Help',
  test401: 'Test401',
} as const;

export type MyAccountRouteName = (typeof NavigationElements)[keyof typeof NavigationElements];

export default NavigationElements;

